import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export default function ErrorToast(msg, details = {}) {

  console.warn(details.error_description || details.message || details);


  Toastify({
    text:
      msg + ". \n" +
      details.error_description ||
      details.message ||
      details,
    duration: 3000,
    newWindow: true,
    close: true,
    gravity: "top", // `top` or `bottom`
    position: "center", // `left`, `center` or `right`
    stopOnFocus: true, // Prevents dismissing of toast on hover
    style: {
      background: "var(--primary-500)",
    },
    onClick: function () { }, // Callback after click
  }).showToast();
}

